module.exports = "<div class=\"btn btn-icon btn-success pull-right\" ng-click=\"query = undefined;\n         add();\" ng-if=jdroPerms.CREATE> <i ng-class=\"'fa ' + infoAdd.icon + ' fa-lg'\" aria-hidden=true></i> {{ infoAdd.message | translate }} </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableButtonAdd.html
// module id = 373
// module chunks = 0